<!--  -->
<template>
  <div>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="130px" class="demo-ruleForm">
      <el-form-item label="活动标题" prop="title">
        <el-input v-model="ruleForm.title" style="width:300px" />
        <div><i class="el-icon-info" style="margin-right:5px" />仅前台展示，且前端活动页面标题取活动标题配置</div>
      </el-form-item>

      <el-form-item label="活动名称" prop="name">
        <el-input v-model="ruleForm.name" v-model.trim="ruleForm.name" style="width:300px" @input="ruleForm.name = ruleForm.name.replace(reg, '')" />
        <div><i class="el-icon-info" style="margin-right:5px" />仅后台展示</div>
      </el-form-item>
      <!--
      <el-form-item label="商品类型" prop="commodityradio">
        <el-radio v-model="ruleForm.commodityradio" :label="4">直赠</el-radio>
      </el-form-item> -->

      <el-form-item label="活动金额" prop="money">
        <el-input v-model="ruleForm.money" style="width:300px" disabled />
        <el-button type="primary" style="margin-left:10px" @click="selectResources">选择资源</el-button>
      </el-form-item>

      <el-form-item label="限购类型">
        <el-radio-group v-model="ruleForm.purchase">
          <el-radio :label="1">按活动限购</el-radio>
          <el-radio :label="2">按天限购</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="限购次数" prop="frequency">
        <el-select v-model="ruleForm.frequency" placeholder="请选择活动区域">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="限购份数" prop="limitquota">
        <el-input v-model="ruleForm.limitquota" style="width:300px" />
      </el-form-item>
      <el-form-item label="期限选择">
        <el-select v-model="time_type" placeholder="请选择">
          <el-option
            v-for="item in timeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="time_type === 2" label="固定天数" prop="appoint_day">
        <el-input v-model="ruleForm.appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="ruleForm.appoint_day = ruleForm.appoint_day.replace(/[^A-z0-9]/, '')" />
      </el-form-item>
      <el-form-item v-if="time_type === 1" label="选择时间" prop="timearr">
        <el-date-picker
          v-model="ruleForm.timearr"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalue"
        />
      </el-form-item>

      <el-form-item label="活动时间是否展示" prop="activityshow">
        <el-radio-group v-model="ruleForm.activityshow">
          <el-radio :label="1">展示</el-radio>
          <el-radio :label="2">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="状态" prop="state">
        <el-radio-group v-model="ruleForm.state">
          <el-radio :label="1">正常</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="弹窗状态" prop="popup">
        <el-radio-group v-model="ruleForm.popup" @change="poposition">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="ruleForm.popup == 1" label="弹窗位置" prop="checkList">
        <el-checkbox-group v-model="ruleForm.checkList" @change="handleCheckedDatesChange">
          <el-checkbox v-for="date in dates" :key="date.key" :label="date.key">{{ date.label }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item v-if="ruleForm.popup == 1" label="弹窗曝光人群" prop="exposure">
        <el-radio-group v-model="ruleForm.exposure" @change="popositioncrowd">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1" disabled>用户画像</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="ruleForm.popup == 1 && ruleForm.exposure == 1" label="选择用户画像" prop="photoid">
        <el-tag v-if="ruleForm.photoid">{{ ruleForm.photoname }}</el-tag>
        <el-button type="primary" size="mini">选择用户画像</el-button>
      </el-form-item>

      <!-- <el-form-item label="活动模板" prop="activityid">
        <el-input v-model="ruleForm.activityid" style="width:100px;margin-right:10px;display:none" disabled />
        <el-tag v-if="ruleForm.activityid" style="margin-right:10px">{{ ruleForm.activityname }}</el-tag>
        <el-button type="primary" size="mini" @click="chooseactivitytem">选择活动模板</el-button>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="资源"
      :visible.sync="resourcesdialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <resourcesdialogtwo ref="resourcesview" @callback="callback" />
    </el-dialog>
    <el-dialog
      title="活动模板"
      :visible.sync="activitydialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <activitytemplate ref="activityview" @callbacktemp="callbacktemp" />
    </el-dialog>
  </div>
</template>

<script>
import resourcesdialogtwo from './resourcesdialogtwo.vue'
import activitytemplate from './activitytemplate.vue'
import { readingservice } from '@/api/sourceMaterial.js'
export default {
  components: {
    resourcesdialogtwo,
    activitytemplate
  },
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAge = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.timearr[0] == this.ruleForm.timearr[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      ruleForm: {
        title: '',
        name: '',
        // commodityradio: 4,
        limitquota: '',
        money: '',
        config_id: null,
        purchase: 1,
        frequency: '',
        timearr: [],
        activityshow: 1,
        state: 1,
        popup: 0,
        checkList: [],
        exposure: 0,
        photoid: '',
        photoname: '',
        // activityid: '',
        activityname: '',
        appoint_day: ''
      },
      starttime: '',
      endtime: '',
      dates: [
        {
          key: 0,
          label: '最近阅读'
        }, {
          key: 1,
          label: '男生'
        },
        {
          key: 2,
          label: '女生'
        },
        {
          key: 3,
          label: '个人中心'
        }
      ],
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2,
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      obj: {},
      resourcesdialogVisible: false,
      activitydialogVisible: false,
      options: [{
        value: '1',
        label: '1次'
      }, {
        value: '2',
        label: '2次'
      }, {
        value: '3',
        label: '3次'
      }, {
        value: '4',
        label: '4次'
      }, {
        value: '5',
        label: '5次'
      }],
      rules: {
        title: [
          { required: true, message: '请输入活动标题', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        limitquota: [
          { required: true, message: '请输入限购份数', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '请选择活动金额', trigger: 'change' }
        ],
        frequency: [
          { required: true, message: '请选择限购次数', trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        timearr: [
          { type: 'array', required: true, message: '选择时间', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ],
        checkList: [
          { type: 'array', required: true, message: '请至少选择一个位置', trigger: 'change' }
        ],
        photoid: [
          { required: true, message: '请选择用户画像', trigger: 'change' }
        ]
        // activityid: [
        //   { required: true, message: '请选择活动模板', trigger: 'change' }
        // ]
      }

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    submitForm(formName) {
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!')
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.starttime
            par.end_time = this.endtime
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.ruleForm.appoint_day)
          }
          readingservice({
            activity_info: {
              row: {
                ...this.obj,
                name: this.ruleForm.title,
                copywriting: this.ruleForm.name,
                // resource_type: this.ruleForm.commodityradio,
                limit_quota: this.ruleForm.limitquota,
                config_id: this.ruleForm.config_id,
                config_name: this.ruleForm.money,
                limited_type: this.ruleForm.purchase,
                limited: this.ruleForm.frequency,
                // starttime: this.starttime,
                // endtime: this.endtime,
                time_show: this.ruleForm.activityshow,
                status: this.ruleForm.state,
                pop_status: this.ruleForm.popup,
                pop_picture_status: this.ruleForm.exposure,
                user_picture_ids: this.ruleForm.photoid
              }
            },
            platform_id: this.platformid,
            activity_type: 4,
            ...par
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.$emit('close')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 选择资源
    selectResources() {
      this.resourcesdialogVisible = true
      this.$nextTick(() => {
        this.$refs.resourcesview.send(this.platformid)
      })
    },
    callback(item) {
      console.log('item', item)
      this.resourcesdialogVisible = false
      this.ruleForm.money = item.name
      this.ruleForm.config_id = item.config_id
    },
    datavalue(val) {
      this.starttime = val[0]
      this.endtime = val[1]
      // console.log('val', val)
    },
    handleCheckedDatesChange(val) {
      this.obj = {}
      for (let i = 0; i < val.length; i++) {
        this.obj[`par[${val[i]}]`] = val[i]
      }
    },
    chooseactivitytem() {
      this.activitydialogVisible = true
      this.$nextTick(() => {
        this.$refs.activityview.send(this.platformid, 1)
      })
    },
    poposition(val) {
      // 弹窗位置回调
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 0) {
        console.log('关闭')
        this.obj = {}
        this.ruleForm.checkList = []
        this.ruleForm.exposure = 0
        this.ruleForm.photoid = ''
        this.ruleForm.photoname = ''
      } else {
        console.log('开启')
      }
    },
    popositioncrowd(val) {
      console.log(val)
      // eslint-disable-next-line eqeqeq
      if (val == 0) {
        this.ruleForm.photoid = ''
        this.ruleForm.photoname = ''
      }
    },
    callbacktemp(val) {
      this.activitydialogVisible = false
      this.ruleForm.activityid = val
      this.ruleForm.activityname = val
      console.log('val', val)
    }
  }
}
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
/deep/ .el-input__inner::-webkit-outer-spin-button,
 /deep/ .el-input__inner::-webkit-inner-spin-button {
-webkit-appearance: none;
 }
/deep/ .el-input__inner[type='number'] {
-moz-appearance: textfield;
 }
 @media (max-width: 768px){

 }
</style>
